import './modules';
import '@emartech/vce-image-properties/dist/src/components/image-properties-dialog';
import '@emartech/vce-image-properties/dist/src/components/image-properties-dialog-tab';
import '@emartech/vce-image-properties/dist/src/components/image-properties-dialog-warnings';
